function EndpointStatusService($rootScope, $log, $filter) {
    let rootScope = $rootScope;
    let log = $log;
    let allSpeakers = {}; // this is a hash of hashes.
    let filter = $filter;
    let mylocalUserPriority; 

    log.debug("EndpointStatusService initialized");

    rootScope.$on('endpointModel.presenceUpdated', function(event, endpointMap, channelId, endpointId, userName) {
        if ( !endpointMap.has(endpointId) ) {
            removeSpeaker(channelId, endpointId);
        }
    });

    rootScope.$on('wtcpjsService.endpoint.gone', function(event, endpointId) {
        // remove the endpoint from any channel they might be speaking on
        for (var property in allSpeakers) {
            if (allSpeakers.hasOwnProperty(property)) {
                removeSpeaker(parseInt(property), endpointId);
            }
        }

        log.info("removed disconnected speaker - " + endpointId);
    });

    rootScope.$on('feedModel.feedEventReceived', function(event, data) {
        if (data.type === "speaking") {
            // check whether we get UP here
            // console.log(`current speakers 'UP'  ${data.data.UP} or ${data.data['UP']}, isSelf=${data.data.self}`);
            addSpeaker(data.channelId, data.name, data.clientTime, data.data.endpointId, data.data.UP, data.data.self);
        } else if (data.type === "end-speaking") {
            removeSpeaker(data.channelId, data.data.endpointId);
        }
    });

    function addSpeaker (channelId, name, clientTime, endpointId, userPriority, self) {
        let channelSpeakerMap = getChannelSpeakersMap(channelId);
        channelSpeakerMap[endpointId] = { name, clientTime, userPriority, self };
        broadcastChannelSpeakerChanges(channelId, channelSpeakerMap);
    }

    function removeSpeaker (channelId, endpointId) {
        let channelSpeakerMap = getChannelSpeakersMap(channelId);
        if (channelSpeakerMap[endpointId]) {
            delete channelSpeakerMap[endpointId];
            broadcastChannelSpeakerChanges(channelId, channelSpeakerMap);
        }
    }

    function broadcastChannelSpeakerChanges (channelId, channelSpeakerMap) {
        let speakerCount = Object.keys(channelSpeakerMap).length;
        let speakersCommaDelimitedList = Object.keys(channelSpeakerMap).map(s => truncateIfNeeded(channelSpeakerMap[s].name)).join(', ');
        let message = `${speakersCommaDelimitedList} ${ speakerCount > 1 ? 'are' : 'is'} speaking.`;
        let eventData = { channelId, speakerCount, speakersCommaDelimitedList, message };

        rootScope.$broadcast('endpointStatusService.speakersChanged', eventData);
        //logChannelSpeakers(eventData);
    }

    function truncateIfNeeded(name) {
        return filter('truncate')(name, 20);
    }

    function getChannelSpeakersMap(channelId) {
        let channelSpeakerMap = allSpeakers[channelId] = allSpeakers[channelId] || {}; // init and return
        return channelSpeakerMap;
    }

    function logChannelSpeakers(data) {
        log.info("speakers: ", data);
    }

    return {
        getSpeakersForChannel(channelId) { return getChannelSpeakersMap(channelId); },

        /**
         * Returns a boolean whether someone is currently speaking on a channel
         * @param channelId
         * @returns {boolean}
         */

        isAnyoneSpeakingOnChannel(channelId) { return Object.keys(this.getSpeakersForChannel(channelId)).length > 0; },

        /**
         * check whether there is any speaker having equal or higher priority
         * -- keep this future extension purpose (disable PTT button when equal or higher priority user speaks on simplex channnel)
         * @param channelId 
         */
        isHigherOrEqualPrioritySpeakingOnChannel(channelId) {
            var speakers = this.getSpeakersForChannel(channelId);
            let mylocalUserPriority = 10; // default 
            let remoteHigherOrEqualPriority = 10; // set default priority
            Object.keys(speakers).forEach(function(key) {
                if(speakers[key].hasOwnProperty("userPriority")) {
                    var speakerPriority = parseInt(speakers[key].userPriority);
                    if(speakers[key].self) {
                        mylocalUserPriority = speakerPriority;
                    }
                    else if (speakerPriority < remoteHigherOrEqualPriority) {
                            remoteHigherOrEqualPriority = speakerPriority; ;  
                        }
                    }
                  //  console.log(key, speakers[key]);
                });
           
            return remoteHigherOrEqualPriority < mylocalUserPriority; }
    }
}

angular
    .module('webcomm')
    .factory('endpointStatusService', ['$rootScope', '$log', '$filter', EndpointStatusService]);